import { SvgIcon, SvgIconProps } from "@mui/material";

export function TrailerIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M4,14 L5.76380548,14.0000983 C6.31312878,13.3862919 7.11145274,13 8,13 C8.84371358,13 9.60607899,13.3482929 10.151161,13.9089434 L17,13.909 L17,8 L4,8 L4,14 Z M8,15 C7.44771525,15 7,15.4477153 7,16 C7,16.5522847 7.44771525,17 8,17 C8.55228475,17 9,16.5522847 9,16 C9,15.4477153 8.55228475,15 8,15 Z M2,8 C2,6.8954305 2.8954305,6 4,6 L17,6 C18.1045695,6 19,6.8954305 19,8 L19,13.909 L22,13.9090909 L22,16.0909091 L10.9986623,16.0904572 C10.9508357,17.705466 9.62659514,19 8,19 C6.34314575,19 5,17.6568542 5,16 L2,16 Z" />
    </SvgIcon>
  );
}
